import moment from 'moment';

export const getSemester = (): "fall" | "summer" | "spring" => {
  const day = moment().dayOfYear();
  const fallStart = moment('2000-08-01').dayOfYear();
  const summerStart = moment('2000-06-01').dayOfYear();

  if (day >= fallStart) {
    return 'fall';
  }
  if (day >= summerStart) {
    return 'summer';
  }
  return 'spring';
};
